import { useMount } from '@shared/utils/hooks/useMount';

import { MAX_ACQUISITION_CONTEXTS } from './acquisitionContextTracking.constants';
import { readAcquisitionContexts, writeAcquisitionContexts } from './acquisitionContextTracking.storage';
import type { StoredAcquisitionContextDetails, StoredAcquisitionContextData } from './acquisitionContextTracking.types';

function saveCurrentAcquisitionContext(locationParam: Location, referrer: string): void {
  const acquisitionContextData: StoredAcquisitionContextData[] = [];
  const searchParams = new URLSearchParams(locationParam.search);
  searchParams.forEach((value, key) => {
    if (key && value) {
      acquisitionContextData.push({ key, value });
    }
  });

  const acquisitionContext: StoredAcquisitionContextDetails = {
    timestamp: Date.now(),
    relativeUrl: locationParam.pathname,
    referrer,
    data: acquisitionContextData,
  };

  const newAcquisitionContexts = readAcquisitionContexts().concat(acquisitionContext);
  if (newAcquisitionContexts.length > MAX_ACQUISITION_CONTEXTS) {
    newAcquisitionContexts.shift();
  }

  writeAcquisitionContexts(newAcquisitionContexts);
}

export function useSaveCurrentAcquisitionContext(locationParam?: Location, referrer?: string): void {
  useMount(() => {
    // Defaults are resolved here (inside useMount → useEffect) so they only
    // evaluate on the client. Evaluating them as default parameter values
    // throws during SSR because `window` and `document` are undefined.
    saveCurrentAcquisitionContext(locationParam ?? window.location, referrer ?? document.referrer);
  });
}
